export const SLOT_TIMES = [
  { label: "9:00 AM", h: 9, m: 0 },
  { label: "10:00 AM", h: 10, m: 0 },
  { label: "11:30 AM", h: 11, m: 30 },
  { label: "1:00 PM", h: 13, m: 0 },
  { label: "2:30 PM", h: 14, m: 30 },
  { label: "4:00 PM", h: 16, m: 0 },
];

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function getAvailableDays(count = 8) {
  const days = [];
  const d = new Date();
  d.setDate(d.getDate() + 1);
  while (days.length < count) {
    if (d.getDay() !== 0) {
      days.push({
        key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`,
        dayName: DAY_NAMES[d.getDay()],
        monthName: MONTHS[d.getMonth()],
        dayNum: d.getDate(),
        year: d.getFullYear(),
      });
    }
    d.setDate(d.getDate() + 1);
  }
  return days;
}

// DST-aware America/Chicago offset for a given date
function centralOffset(dayKey) {
  const probe = new Date(`${dayKey}T12:00:00Z`);
  const part = new Intl.DateTimeFormat("en-US", { timeZone: "America/Chicago", timeZoneName: "shortOffset" })
    .formatToParts(probe)
    .find((p) => p.type === "timeZoneName");
  const m = part && part.value.match(/GMT([+-]\d+)/);
  const off = m ? parseInt(m[1], 10) : -5;
  return `${off < 0 ? "-" : "+"}${String(Math.abs(off)).padStart(2, "0")}:00`;
}

export function slotToIso(dayKey, time) {
  const hh = String(time.h).padStart(2, "0");
  const mm = String(time.m).padStart(2, "0");
  return `${dayKey}T${hh}:${mm}:00${centralOffset(dayKey)}`;
}

export function slotLabel(day, time) {
  return `${day.dayName}, ${day.monthName} ${day.dayNum} at ${time.label} CST`;
}

const toUtcStamp = (date) =>
  date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

export function calendarLinks(slotStartIso, slotLabelText) {
  const start = new Date(slotStartIso);
  const end = new Date(start.getTime() + 45 * 60000);
  const title = encodeURIComponent("Debt-Free Life — 1-on-1 Strategy Call with Najiyyah Qaasim");
  const details = encodeURIComponent(
    "Your free 1-on-1 Strategy Call with Najiyyah Qaasim (QandQinsurance). Have your rough mortgage balance and monthly debt payments handy — we handle the math. Questions? najiyyahq@gmail.com"
  );
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${toUtcStamp(start)}/${toUtcStamp(end)}&details=${details}&location=${encodeURIComponent("Phone Call")}`;

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Debt-Free Life//Strategy Call//EN",
    "BEGIN:VEVENT",
    `UID:dfl-${start.getTime()}@debtfreelife`,
    `DTSTAMP:${toUtcStamp(new Date())}`,
    `DTSTART:${toUtcStamp(start)}`,
    `DTEND:${toUtcStamp(end)}`,
    "SUMMARY:Debt-Free Life — 1-on-1 Strategy Call with Najiyyah Qaasim",
    `DESCRIPTION:Your free 1-on-1 Strategy Call (${slotLabelText}). Have your rough mortgage balance and monthly debt payments handy.`,
    "LOCATION:Phone Call",
    "BEGIN:VALARM",
    "TRIGGER:-PT30M",
    "ACTION:DISPLAY",
    "DESCRIPTION:Strategy Call in 30 minutes",
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  return { google, ics };
}
